import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from '@xpo/security';
import { DashboardComponent } from './dashboard/dashboard.component';

import { AuthorizationGuard } from '../core/index';
import { SignedoutComponent } from './signedout/signedout.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/dashboard',
      },
      { path: 'dashboard', component: DashboardComponent, canActivate: [AuthorizationGuard] },
      { path: 'signedout', component: SignedoutComponent },
      { path: 'applications', loadChildren: 'application.bloc/app.module#ApplicationBlocModule', canActivate: [AuthorizationGuard], data: { permissions: ['applications'] } },
      { path: 'users', loadChildren: 'users.bloc/users.module#UsersBlocModule', canActivate: [AuthorizationGuard], data: { permissions: ['users'] } },
      // {path: '**', redirectTo: '/pagenotfound'}
    ]),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/app.routes.ts